import React from 'react';
import PropTypes from 'prop-types';

import TileImage from 'src/components/Tile/TileImage';
import styles from 'src/components/Tile/TileCompanyDetails.scss';

import ClockFast from '@mdi/svg/svg/clock-fast.svg';
import MapMarker from '@mdi/svg/svg/map-marker.svg';


const apply = 'Aplikuj szybko';

const renderLocation = location => (
  <div className={ styles.information__wrapper }>
    <MapMarker className={ styles.location__icon } viewBox="0 0 24 24" />
    <h5 className={ [styles.information__location, styles.location].join(' ') }>
      {location}
    </h5>
  </div>
);

const TileCompanyDetails = function ({
  company,
  location,
  logo,
  isOneClickApply
}) {
  return (
    <div className={ styles.company }>
      <TileImage alt={ company } className={ styles.company__logo } source={ logo } />
      <div
        className={ [styles.company__information, styles.information].join(' ') }
      >
        <h4 className={ styles.information__name }>{company}</h4>
        <div
          className={ [styles.information__location, styles.location].join(' ') }
        >
          {renderLocation(location)}
        </div>
        {isOneClickApply && (
          <div
            className={ [
              styles.information__oneClickApply,
              styles.oneClickApply,
              styles.information__wrapper
            ].join(' ') }
          >
            <ClockFast
              className={ styles.oneClickApply__icon }
              viewBox="0 0 24 24"
            />
            <h5
              className={ [
                styles.information__oneClickApply, styles.oneClickApply
              ].join(' ') }
            >
              {apply}
            </h5>
          </div>
        )}
      </div>
    </div>
  );
};

TileCompanyDetails.propTypes = {
  company: PropTypes.string.isRequired,
  isOneClickApply: PropTypes.bool.isRequired,
  location: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired
};

export default TileCompanyDetails;
